import React from 'react';
import Logo from '../common/Logo';
import './Footer.css';

const Footer = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <footer>
      <div className="wrap">
        <div className="footer-grid">
          <div>
            <Logo />
            <p className="fbrand-p">ارائه‌دهنده خدمات دیتاسنتر، سرور مجازی و اختصاصی، میزبانی وب و ثبت دامنه در ایران و هلند</p>
            <div className="fsocial">
              <a href="https://t.me/afracell" target="_blank" rel="noopener noreferrer" aria-label="تلگرام">✈️</a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="اینستاگرام">📷</a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="لینکدین">💼</a>
            </div>
          </div>
          <div className="fcol">
            <h4>خدمات</h4>
            <ul>
              <li><button onClick={() => scrollTo('services')}>سرور اختصاصی</button></li>
              <li><button onClick={() => scrollTo('services')}>سرور VPS</button></li>
              <li><button onClick={() => scrollTo('hosting')}>هاست cPanel</button></li>
              <li><button onClick={() => scrollTo('hosting')}>هاست DirectAdmin</button></li>
              <li><button onClick={() => scrollTo('hosting')}>هاست وردپرس</button></li>
            </ul>
          </div>
          <div className="fcol">
            <h4>محصولات</h4>
            <ul>
              <li><button onClick={() => scrollTo('domain')}>ثبت دامنه</button></li>
              <li><button onClick={() => scrollTo('contact')}>فضای بکاپ</button></li>
              <li><button onClick={() => scrollTo('contact')}>تلفن ابری</button></li>
              <li><button onClick={() => scrollTo('licenses')}>لایسنس cPanel</button></li>
              <li><button onClick={() => scrollTo('licenses')}>WHMCS</button></li>
            </ul>
          </div>
          <div className="fcol">
            <h4>پشتیبانی</h4>
            <ul>
              <li><a href="https://hub.afracell.com" target="_blank" rel="noopener noreferrer">پنل مشتریان</a></li>
              <li><button onClick={() => window.location.href = '#'}>مستندات</button></li>
              <li><button onClick={() => window.location.href = '#'}>سوالات متداول</button></li>
              <li><button onClick={() => window.location.href = '#'}>وضعیت سرویس</button></li>
              <li><button onClick={() => scrollTo('contact')}>تماس با ما</button></li>
            </ul>
          </div>
        </div>
        <div className="footer-bot">
          <p>© ۱۴۰۴ افراسل — تمامی حقوق محفوظ است</p>
          <div className="footer-bot-links">
            <button onClick={() => window.location.href = '#'}>حریم خصوصی</button>
            <button onClick={() => window.location.href = '#'}>شرایط استفاده</button>
            <button onClick={() => window.location.href = '#'}>SLA</button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
